import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class DiagnosticLaunchClickedEventTracking extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.DIAGNOSTIC_LAUNCH_CLICKED;

  formId: string;

  constructor(formId: string) {
    super();
    this.formId = formId;
  }
}
